import uuidv4 from "uuid/v4";
import validate from "util/validate";
import { BasePresenter } from "core/presenter";
import { BarcodeRepository } from "core/repository";
import { BarcodeConstraint } from "core/constraint";
import _ from "lodash";

export default class BarcodesPresenter extends BasePresenter {
  initialState() {
    return {
      loading: false,
      sellable: "",
      currentBarcodes: [],
      newBarcode: "",
      newBarcodeError: "",
      type: "",
      gtin: "",
      pack_barcode: ""
    };
  }

  async onStart() {
    await this.loadBarcodes(this.props.sellable);
  }

  async loadBarcodes(sellable) {
    this.viewModel.loading = true;
    this.viewModel.sellable = sellable;
    const result = await BarcodeRepository.getListOnline({
      order: [
        {
          field: "code",
          direction: "ASC"
        }
      ],
      pagination: {
        page: 1,
        perPage: 25
      },
      filters: [
        {
          field: "sellable_uuid",
          value: this.routeParams.productUuid,
          operation: "EQ"
        }
      ]
    });

    if (result.success) {
      this.viewModel.currentBarcodes = result.data;
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops",
        content: "Não foi possível carregar os códigos de barras desse produto."
      });
    }

    this.viewModel.loading = false;
  }

  async addBarcode(code, type) {
    this.viewModel.loading = true;

    if (!code.length) {
      this.sendNotification({
        type: "error",
        title: "Oooops...",
        content: "Código de barras em branco. Preencha algum valor válido."
      });
    } else {
      let newBarcode = {};
      let codeName = "Código de barras";

      if (type === "gtin") {
        codeName = "GTIN";
      } else if (type === "pack_barcode") {
        codeName = "GTIN/Embalagem";
      }

      const isValid = this.validateBarcode({ code, type, codeName });

      if (isValid) {
        const findResult = await BarcodeRepository.getListOnline({
          order: [
            {
              field: "code",
              direction: "ASC"
            }
          ],
          pagination: {
            page: 1,
            perPage: 25
          },
          filters: [{ field: "code", value: code, operation: "EQ" }]
        });

        const foundResult = findResult.success && findResult.data.length;
        const vmBarcode = this.viewModel.currentBarcodes.find(
          barcode => barcode.code === code && barcode.mode !== "delete"
        );
        const alreadyExists =
          vmBarcode && (!vmBarcode.mode || vmBarcode.mode !== "delete");

        if (foundResult && alreadyExists) {
          this.sendNotification({
            type: "error",
            title: "Oooops...",
            content: "Este código de barras já existe."
          });
        } else if (alreadyExists) {
          this.sendNotification({
            type: "error",
            title: "Oooops...",
            content: `Este código de barras já foi preenchido. Clique em 'SALVAR PRODUTO' para validar as modificações feitas ou adicione outro código de barras.`
          });
        } else {
          newBarcode = {
            code,
            type,
            company_uuid: this.viewModel.sellable.company_uuid,
            account_uuid: this.viewModel.sellable.company_uuid,
            sellable_uuid: this.viewModel.sellable.uuid,
            uuid: uuidv4(),
            mode: "create"
          };

          this.viewModel.currentBarcodes.push(newBarcode);
          this.viewModel.newBarcode = "";
        }
      }
    }

    this.viewModel.type = "";
    this.viewModel.loading = false;
  }

  validateBarcode(barcode) {
    this.viewModel.newBarcodeError = "";
    const constraint = BarcodeConstraint.barCode;

    const validation = validate(barcode, constraint, { fullMessages: false });

    if (!!validation) {
      this.viewModel.newBarcodeError = validation.code[0];
      return false;
    }

    return true;
  }

  async deleteBarcode(barcodeUuid, index) {
    let { currentBarcodes } = this.viewModel;
    this.viewModel.loading = true;
    currentBarcodes.forEach(barcode => {
      if (barcode.uuid === barcodeUuid) {
        barcode.mode = "delete";
        this.props.deleteIndexError(index);
      }
    });
    this.viewModel.loading = false;
  }

  async editBarcode(barcodeUuid, value) {
    let { currentBarcodes } = this.viewModel;
    const index = _.findIndex(currentBarcodes, ["uuid", barcodeUuid]);
    currentBarcodes[index].mode =
      currentBarcodes[index].mode !== "create" || !currentBarcodes[index].mode
        ? "edit"
        : "create";
    currentBarcodes[index].code = value;
    this.props.editBarcode(barcodeUuid, value);
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/product/form/general-info/barcodes/barcodes.presenter.js